import { render, staticRenderFns } from "./PechatFooter.vue?vue&type=template&id=e17bf5c0"
var script = {}
import style0 from "./PechatFooter.vue?vue&type=style&index=0&id=e17bf5c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports